// extracted by mini-css-extract-plugin
export var media = "lead-module--media--2tIsu";
export var description = "lead-module--description--2iyl9";